import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { secretKey } from "../.././data";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import { isArray } from "util";
import EditPelnSub from "./editPelnSub.js";

const MySwal = withReactContent(Swal2);

const AddLetter = (props) => {
  const [showEditPelnSub, setShowEditPelnSub] = useState(false);
  const [letters, setLetters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState("");
  const [bankAddressDb, setBankAddressDb] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [task, setTask] = useState("");
  const [holidays, setHolidays] = useState("");
  const [freeDays, setFreeDays] = useState([]);
  const [plnValue, setPlnValue] = useState(
    props.clientsData.wezwPlnValue === null ? 0 : props.clientsData.wezwPlnValue
  );
  const [chfValue, setChfValue] = useState(
    props.clientsData.wezwChfValue === null ? 0 : props.clientsData.wezwChfValue
  );
  const [curr, setCurr] = useState("");
  const [curr_old, setCurr_old] = useState("");
  const [aggr_points, setAggr_points] = useState("");
  const [court, setCourt] = useState("");
  const [courtDistrict, setCourtDistrict] = useState("");

  function loadFile(url, callback) {
    PizZipUtils.getBinaryContent(url, callback);
  }

  const generateClientName2 = () => {
    var table =
      props.clientsData.petitioner.replaceAll("  ", "").split(",").length > 1
        ? props.clientsData.petitioner.replaceAll("  ", "").split(",")
        : props.clientsData.petitioner;

    var arr = [];

    if (isArray(table)) {
      table.map((el, index) => {
        arr.push({
          name: el[0] === " " ? el.replace(" ", "") : el,
          address: ", " + getAddress(el) + ", PESEL: " + getPesel(el),
        });
      });
      return arr;
    } else {
      return [
        {
          name: table,
          address: ", " + getAddress(table) + ", PESEL: " + getPesel(table),
        },
      ];
      //return table + ", " + getAddress(table) + ", PESEL: " + getPesel(table);
    }
  };

  const generateClientName = () => {
    var table =
      props.clientsData.petitioner.split(",").length > 1
        ? props.clientsData.petitioner.replaceAll("  ", "").split(",")
        : props.clientsData.petitioner;
    var text = ``;

    if (isArray(table)) {
      table.map((el, index) => {
        text =
          text +
          (index + 1) +
          ". " +
          el +
          " (adres w aktach sprawy)" +
          (index + 1 === table.length ? "" : "\n");
      });
      return text.toString();
    } else {
      return table + " (adres w aktach sprawy)";
    }
  };

  const generateClientName3 = () => {
    var table =
      props.clientsData.petitioner.split(",").length > 1
        ? props.clientsData.petitioner.replaceAll("  ", "").split(",")
        : props.clientsData.petitioner;
    var text = ``;

    if (isArray(table)) {
      table.map((el, index) => {
        text = text + el + (index + 1 === table.length ? "" : ",");
      });
      return text.toString();
    } else {
      return table;
    }
  };

  const generateTxtChange1 = () => {
    var table =
      props.clientsData.petitioner.split(",").length > 1
        ? props.clientsData.petitioner.split(",")
        : props.clientsData.petitioner;
    var text = ``;

    if (isArray(table)) {
      return "zastępowani";
    } else {
      return "zastępowany";
    }
  };

  const fetchHolidays = async (hearing) => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidays(data.filter((el) => el.type === "holiday"));
        fetchAggrPoints();
        fetchCourtAddress();
      })
      .catch((error) => {});
  };

  const fetchCourtAddress = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getCourtAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var data = "";

          if (el.addressNew) {
            data = JSON.parse(el.addressNew);
          } else {
            data = {
              street: "",
              number: "",
              postCode: "",
              city: "",
            };
          }

          var addressTxt =
            data.street +
            " " +
            data.number +
            ", " +
            data.postCode +
            " " +
            data.city;

          if (!el.addressNew) {
            addressTxt = "";
          }

          var obj = {
            id: el.id,
            district: el.district,
            name: el.name,
            address: addressTxt,
            addressNew: data,
          };

          arr.push(obj);
        });
        getCurr();
        var districtTxt =
          props.district === "brak" ? "" : props.district + " Wydział Cywilny";
        if (props.clientsData.aCourt === "Sąd Okręgowy w Warszawie") {
          districtTxt = "XXVIII Wydział Cywilny";
        }
        if (
          props.clientsData.aCourt === "Sąd Okręgowy w Poznaniu" &&
          props.district === "XIV"
        ) {
          districtTxt = "XIV Zamiejscowy Wydział Cywilny z siedzibą w Pile";
        }
        setCourt(
          districtTxt +
            "\n" +
            (districtTxt === "XXVIII Wydział Cywilny"
              ? "ul. Przyokopowa 33, 01-208 Warszawa"
              : props.district === "brak"
              ? arr.filter((el) => el.name === props.clientsData.aCourt)[0]
                  .address
              : arr.filter(
                  (el) =>
                    el.name === props.clientsData.aCourt &&
                    el.district.includes(props.district)
                )[0].address)
        );
        setCourtDistrict(districtTxt);
      })
      .catch((error) => {});
  };

  const fetchAggrPoints = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getAggrPoints", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setAggr_points(
          data.filter(
            (el) =>
              el.bank === props.clientsData.bank &&
              new Date(props.clientsData.credit_date).getFullYear() === +el.year
          ).length === 0
            ? data.filter(
                (el) => el.bank === props.clientsData.bank && "brak" === el.year
              )[0].points
            : data.filter(
                (el) =>
                  el.bank === props.clientsData.bank &&
                  new Date(props.clientsData.credit_date).getFullYear() ===
                    +el.year
              )[0].points
        );
      })
      .catch((error) => {});

    fetchBankAddress();
  };

  const subDay = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() - 1));
    return retDate;
  };

  const subDays = (date, days) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() - days));
    return retDate;
  };

  const getAddress = (el) => {
    var additionalData = props.clientsData.additionalData;
    if (additionalData === null) {
      return "";
    }
    var arr = additionalData.split("|");
    if (
      arr.filter(
        (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
      ).length > 0
    ) {
      return arr
        .filter(
          (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
        )[0]
        .split(",")[2]
        .replaceAll(";", ",");
    } else {
      return "";
    }
  };

  const getPesel = (el) => {
    var additionalData = props.clientsData.additionalData;
    if (additionalData === null) {
      return "";
    }
    var arr = additionalData.split("|");
    if (
      arr.filter(
        (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
      ).length > 0
    ) {
      return arr
        .filter(
          (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
        )[0]
        .split(",")[1];
    } else {
      return "";
    }
  };

  const fetchBankAddress = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBankAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];

        data.map((el) => {
          var data = "";

          if (el.addressNew) {
            data = JSON.parse(el.addressNew);
          } else {
            data = {
              street: "",
              number: "",
              postCode: "",
              city: "",
            };
          }

          var addressTxt =
            data.street +
            " " +
            data.number +
            ", " +
            data.postCode +
            " " +
            data.city;

          if (!el.addressNew) {
            addressTxt = "";
          }

          var obj = {
            id: el.id,
            nameSelect: el.nameSelect,
            nameLetter: el.nameLetter,
            bankKRS: el.bankKRS,
            address: addressTxt,
            addressNew: data,
          };

          arr.push(obj);
        });
        setBankAddressDb(
          arr.filter((el) => el.nameSelect === props.clientsData.bank)[0]
        );
        fetchFreeDays();
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDays(data);
        getCurr();
      })
      .catch((error) => {});
  };

  const getCurr = async () => {
    var url = "";
    var day = new Date().getDay();
    var dateX = new Date();
    if (day === 0) {
      dateX = subDays(new Date(), 6);
    }
    if (day === 6) {
      dateX = subDays(new Date(), 5);
    }

    var date =
      new Date(dateX).getFullYear() +
      "-" +
      (new Date(dateX).getMonth() < 10
        ? "0" + (new Date(dateX).getMonth() + 1)
        : new Date(dateX).getMonth() + 1) +
      "-" +
      (new Date(dateX).getDate() < 10
        ? "0" + new Date(dateX).getDate()
        : new Date(dateX).getDate());

    url = `https://api.nbp.pl/api/exchangerates/rates/a/chf/${date}`;

    await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setCurr(data.rates[0].mid);
        getCurr_old();
      })
      .catch(async (error) => {
        var dateY = subDays(new Date(), 1);
        var date2 =
          new Date(dateY).getFullYear() +
          "-" +
          (new Date(dateY).getMonth() < 10
            ? "0" + (new Date(dateY).getMonth() + 1)
            : new Date(dateY).getMonth() + 1) +
          "-" +
          (new Date(dateY).getDate() < 10
            ? "0" + new Date(dateY).getDate()
            : new Date(dateY).getDate());

        url = `https://api.nbp.pl/api/exchangerates/rates/a/chf/${date2}`;

        await fetch(url)
          .then((response) => response.json())
          .then((data) => {
            setCurr(data.rates[0].mid);
            getCurr_old();
          })
          .catch((error) => {
            setCurr(0);
            getCurr_old();
          });
      });
  };

  const getCurr_old = async () => {
    var url = "";
    var day = new Date(props.clientsData.dateWym).getDay();
    var dateX = new Date(props.clientsData.dateWym);
    if (day === 0) {
      dateX = subDays(new Date(props.clientsData.dateWym), 6);
    }
    if (day === 6) {
      dateX = subDays(new Date(props.clientsData.dateWym), 5);
    }
    var date =
      new Date().getFullYear() +
      "-" +
      (new Date(dateX).getMonth() < 10
        ? "0" + (new Date(dateX).getMonth() + 1)
        : new Date(dateX).getMonth() + 1) +
      "-" +
      (new Date(dateX).getDate() < 10
        ? "0" + new Date(dateX).getDate()
        : new Date(dateX).getDate());

    url = `https://api.nbp.pl/api/exchangerates/rates/a/chf/${date}`;

    await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setCurr_old(data.rates[0].mid);
        fetchLetters();
      })
      .catch((error) => {
        setCurr_old(0);
        fetchLetters();
      });
  };

  const fetchLetters = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLetters", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLetters(data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const checkFree = (date) => {
    var blocks = freeDays.filter((el) => el.date === date);

    var bool = false;

    if (blocks.length > 0) {
      bool = true;
    } else {
      bool = false;
    }

    if (new Date(date).getDay() === 0 || new Date(date).getDay() === 6) {
      bool = true;
    }

    return bool;
  };

  const getData = () => {
    setLoading(true);
    fetchHolidays();
  };

  useEffect(() => {
    getData();
  }, []);

  const generateTxtChange2 = () => {
    var table =
      props.clientsData.petitioner.split(",").length > 1
        ? props.clientsData.petitioner.split(",")
        : props.clientsData.petitioner;
    var text = ``;

    if (isArray(table)) {
      return "1";
    } else {
      return "";
    }
  };

  const generateTxtChange3 = () => {
    var table =
      props.clientsData.petitioner.split(",").length > 1
        ? props.clientsData.petitioner.split(",")
        : props.clientsData.petitioner;
    var text = ``;

    if (isArray(table)) {
      return "1 Powód oznacza również powodów.";
    } else {
      return "";
    }
  };

  const getMonthName = (month) => {
    if (month === 1) {
      return "stycznia";
    }
    if (month === 2) {
      return "lutego";
    }
    if (month === 3) {
      return "marca";
    }
    if (month === 4) {
      return "kwietnia";
    }
    if (month === 5) {
      return "maja";
    }
    if (month === 6) {
      return "czerwca";
    }
    if (month === 7) {
      return "lipca";
    }
    if (month === 8) {
      return "sierpnia";
    }
    if (month === 9) {
      return "września";
    }
    if (month === 10) {
      return "października";
    }
    if (month === 11) {
      return "listopada";
    }
    if (month === 12) {
      return "grudnia";
    }
  };

  const getBank = (bank) => {
    if (bank === "Raiffeisen Bank International AG") {
      return "Raiffeisen Bank International AG z siedzibą w Wiedniu działający przez Raiffeisen Bank International AG (Spółka Akcyjna) Oddział w Polsce";
    }
    if (bank === "PKO BP S.A.") {
      return "Powszechna Kasa Oszczędności Bank Polski S.A.";
    }
    if (bank === "PEKAO S.A.") {
      return "Bank Polska Kasa Opieki – Spółka Akcyjna";
    }
    return bank;
  };

  const getPetitionerData = () => {
    var table =
      props.clientsData.petitioner.replaceAll("  ", "").split(",").length > 1
        ? props.clientsData.petitioner.replaceAll("  ", "").split(",")
        : props.clientsData.petitioner;

    var arr = [];

    if (isArray(table)) {
      table.map((el, index) => {
        arr.push({
          name: el,
          address: ", " + getAddress(el) + ", PESEL: " + getPesel(el),
        });
      });
      return arr;
    } else {
      return [
        {
          name: table,
          address: ", " + getAddress(table) + ", PESEL: " + getPesel(table),
        },
      ];
      //return table + ", " + getAddress(table) + ", PESEL: " + getPesel(table);
    }
  };

  const numberWithCommas = (x) => {
    return x
      .toString()
      .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ")
      .replaceAll(".", ",");
  };

  const generateDocument = () => {
    loadFile(template, function (error, content) {
      if (error) {
        throw error;
      }
      var zip = new PizZip(content);
      var doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
      });
      var bankTr = getBank(props.clientsData.bank);
      var plnValueTr2 =
        +plnValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
          ? numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.wezwPlnValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") +
                    +props.clientsData.wezwChfValue
                      .toString()
                      .replaceAll(" ", "")
                      .replaceAll(",", ".") *
                      curr +
                    +props.clientsData.credit_value
                      .split(" ")[0]
                      .replaceAll(" ", "")
                      .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )
          : "";

      var plnValueTr3 =
        +plnValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
          ? numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.wezwPlnValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") +
                    (+props.clientsData.wezwChfValue
                      .replaceAll(" ", "")
                      .replaceAll(",", ".") > 0
                      ? +props.clientsData.wezwChfValue
                          .toString()
                          .replaceAll(" ", "")
                          .replaceAll(",", ".") * curr
                      : 0)
                ).toFixed(2)
              ).toFixed(2)
            )
          : "";
      var plnValueTr =
        +plnValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
          ? numberWithCommas(
              parseFloat(
                parseFloat(
                  props.clientsData.wezwPlnValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )
          : "";
      var plnTextTr =
        +plnValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
          ? " PLN"
          : "";
      var chfValueTr = numberWithCommas(
        parseFloat(
          parseFloat(
            +props.clientsData.wezwChfValue
              .toString()
              .replaceAll(" ", "")
              .replaceAll(",", ".")
          ).toFixed(2)
        ).toFixed(2)
      );
      var dateWezwTxt =
        (new Date(props.clientsData.data_wezw).getDate() < 10
          ? "0" + new Date(props.clientsData.data_wezw).getDate()
          : new Date(props.clientsData.data_wezw).getDate()) +
        " " +
        getMonthName(new Date(props.clientsData.data_wezw).getMonth() + 1) +
        " " +
        new Date(props.clientsData.data_wezw).getFullYear() +
        " r.";
      var dateDeliwerTxt =
        (new Date(props.clientsData.dateDeliverWezw).getDate() < 10
          ? "0" + new Date(props.clientsData.dateDeliverWezw).getDate()
          : new Date(props.clientsData.dateDeliverWezw).getDate()) +
        " " +
        getMonthName(
          new Date(props.clientsData.dateDeliverWezw).getMonth() + 1
        ) +
        " " +
        new Date(props.clientsData.dateDeliverWezw).getFullYear() +
        " r.";
      var datePrintTxt =
        (new Date(props.clientsData.printDate).getDate() < 10
          ? "0" + new Date(props.clientsData.printDate).getDate()
          : new Date(props.clientsData.printDate).getDate()) +
        " " +
        getMonthName(new Date(props.clientsData.printDate).getMonth() + 1) +
        " " +
        new Date(props.clientsData.printDate).getFullYear() +
        " r.";
      var dateSendTxt =
        (new Date(props.clientsData.sendDate).getDate() < 10
          ? "0" + new Date(props.clientsData.sendDate).getDate()
          : new Date(props.clientsData.sendDate).getDate()) +
        " " +
        getMonthName(new Date(props.clientsData.sendDate).getMonth() + 1) +
        " " +
        new Date(props.clientsData.sendDate).getFullYear() +
        " r.";
      var creditDateText =
        (new Date(props.clientsData.credit_date).getDate() < 10
          ? "0" + new Date(props.clientsData.credit_date).getDate()
          : new Date(props.clientsData.credit_date).getDate()) +
        " " +
        getMonthName(new Date(props.clientsData.credit_date).getMonth() + 1) +
        " " +
        new Date(props.clientsData.credit_date).getFullYear() +
        " r.";

      var creditValueCurr = props.clientsData.credit_value.split(" ")[1];
      var creditValueVal = numberWithCommas(
        parseFloat(
          parseFloat(
            props.clientsData.credit_value
              .split(" ")[0]
              .replaceAll(" ", "")
              .replaceAll(",", ".")
          ).toFixed(2)
        ).toFixed(2)
      );
      var creditValueText = creditValueVal + " " + creditValueCurr;

      var sum = 0;
      if (
        props.clientsData.credit_value.split(" ")[1] === "PLN" &&
        (+props.clientsData.wezwChfValue
          .replaceAll(" ", "")
          .replaceAll(",", ".") === undefined ||
          +props.clientsData.wezwChfValue
            .replaceAll(" ", "")
            .replaceAll(",", ".") === 0) &&
        +props.clientsData.wezwPlnValue
          .replaceAll(" ", "")
          .replaceAll(",", ".") > 0
      ) {
        sum = parseFloat(
          parseFloat(
            +props.clientsData.credit_value
              .replaceAll(" ", "")
              .replaceAll("CHF", "")
              .replaceAll("PLN", "") +
              +props.clientsData.wezwPlnValue
                .replaceAll(" ", "")
                .replaceAll(",", ".")
          ).toFixed(2)
        ).toFixed(2);
      }

      if (
        props.clientsData.credit_value.split(" ")[1] === "PLN" &&
        +props.clientsData.wezwChfValue
          .replaceAll(" ", "")
          .replaceAll(",", ".") > 0 &&
        +props.clientsData.wezwPlnValue
          .replaceAll(" ", "")
          .replaceAll(",", ".") > 0
      ) {
        sum = parseFloat(
          parseFloat(
            +props.clientsData.credit_value
              .replaceAll(" ", "")
              .replaceAll("CHF", "")
              .replaceAll("PLN", "") +
              +props.clientsData.wezwPlnValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") +
              +props.clientsData.wezwChfValue
                .toString()
                .replaceAll(" ", "")
                .replaceAll(",", ".") *
                +curr
          ).toFixed(2)
        ).toFixed(2);
      }

      if (
        props.clientsData.realCreditValue
          ? +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0
          : false &&
            +props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") !== undefined &&
            (+props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === undefined ||
              +props.clientsData.wezwChfValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") === 0)
      ) {
        sum = parseFloat(
          parseFloat(
            +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") +
              +props.clientsData.wezwPlnValue
                .replaceAll(" ", "")
                .replaceAll(",", ".")
          ).toFixed(2)
        ).toFixed(2);
      }

      if (
        props.clientsData.realCreditValue
          ? +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0
          : false &&
            +props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") !== undefined &&
            +props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") !== undefined &&
            +props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0
      ) {
        sum = parseFloat(
          parseFloat(
            +props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") +
              +props.clientsData.wezwChfValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") *
                +curr +
              +props.clientsData.realCreditValue
                .replaceAll(" ", "")
                .replaceAll(",", ".")
          ).toFixed(2)
        ).toFixed(2);
      }
      if (
        props.clientsData.realCreditValue
          ? +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === undefined ||
            +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === 0
          : false &&
            +props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") !== undefined &&
            +props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0 &&
            +props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") !== undefined &&
            +props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0
      ) {
        sum = parseFloat(
          parseFloat(
            +props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") +
              +props.clientsData.wezwChfValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") *
                +curr +
              +props.clientsData.credit_value
                .replaceAll("CHF", "")
                .replaceAll("PLN", "")
                .replaceAll(" ", "")
                .replaceAll(",", ".") *
                +curr
          ).toFixed(2)
        ).toFixed(2);
      }

      if (
        props.clientsData.realCreditValue
          ? +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === undefined ||
            +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === 0
          : false &&
            (+props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") !== undefined ||
              +props.clientsData.wezwPlnValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") > 0) &&
            (+props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === undefined ||
              +props.clientsData.wezwChfValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") === 0)
      ) {
        sum = parseFloat(
          parseFloat(
            +props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") +
              +props.clientsData.credit_value
                .replaceAll("CHF", "")
                .replaceAll("PLN", "")
                .replaceAll(" ", "")
                .replaceAll(",", ".") *
                +curr
          ).toFixed(2)
        ).toFixed(2);
      }

      doc.setData({
        date:
          (new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate()) +
          " " +
          getMonthName(new Date().getMonth() + 1) +
          " " +
          new Date().getFullYear() +
          " r.",
        bankSimple: bankTr,
        knadPLN: props.clientsData.nadPLN
          ? numberWithCommas(parseFloat(props.clientsData.nadPLN)) + " PLN"
          : "",
        knadCHF: props.clientsData.nadCHF
          ? numberWithCommas(parseFloat(props.clientsData.nadCHF)) + " CHF"
          : "",
        last_date: props.clientsData.lawsuit_date,
        court: props.clientsData.aCourt,
        sygn: props.clientsData.aSygn,
        petitioner: generateClientName(),
        petitioner2: generateClientName3(),
        txt_change1: generateTxtChange1(),
        txt_change2: generateTxtChange2(),
        txt_change3: generateTxtChange3(),
        court_address:
          (props.district === "XIV"
            ? "XIV Zamiejscowy Wydział Cywilny z siedzibą w Pile \n"
            : props.district + " Wydział Cywilny \n") +
          props.courtAddress.replaceAll(",", "\n"),
        court_district: props.district + " Wydział Cywilny \n",
        lawyer_bank:
          props.clientsData.lawyer_bank === null ||
          props.clientsData.lawyer_bank === undefined ||
          props.clientsData.lawyer_bank === ""
            ? ""
            : (props.clientsData.petitioner.split(",").length > 1
                ? "zastępowani przez: "
                : "zastępowany przez: ") +
              props.clientsData.lawyer_bank +
              ", " +
              ((props.clientsData.lawoffice_bank
                ? props.clientsData.lawoffice_bank.split("/n").length > 0
                  ? props.clientsData.lawoffice_bank.split("/n")[0]
                  : props.clientsData.lawoffice_bank
                : "") +
                ", " +
                props.bankLawOfficeAddress),
        lawoffice_bank:
          props.clientsData.lawoffice_bank === null
            ? ""
            : props.clientsData.lawoffice_bank +
              ", " +
              props.bankLawOfficeAddress,
        client_mail: props.clientsData.email.split(",")[0],
        client_phone: props.clientsData.phone.split(",")[0],

        hasInd:
          +props.clientsData.wezwPlnValue
            .replaceAll(" ", "")
            .replaceAll(",", ".") !== undefined &&
          +props.clientsData.wezwChfValue
            .replaceAll(" ", "")
            .replaceAll(",", ".") === undefined
            ? true
            : false,
        court: props.clientsData.aCourt,
        court_address: court,
        court_district: courtDistrict,
        ge_text_new: props.clientsData.bank_old.includes("Money Bank")
          ? `Powód zwraca uwagę, że zgodnie z aktualnym stanowiskiem Sądu Najwyższego wyrażonym w uzasadnieniu postanowienia z dnia 7 lutego 2023 r., sygn. akt: I CSK 4195/22 (www.sn.pl) nie ma możliwości usunięcia części nieuczciwego elementu warunku umowy poprzez wykreślenie z § 17 marży kupna/marży sprzedaży. Z cytowanego orzeczenia wynika, że „z wyroku TSUE wydanego w sprawie C-19/20 nie wynika jednolity sposób traktowania zobowiązania do uiszczenia na rzecz kredytującego banku marży. Zobowiązanie takie wynika bowiem z treści konkretnej umowy zawieranej przez strony i podlega zasadom wykładni oświadczeń woli. Wykładnia ta, dokonywana w każdym przypadku, prowadzi do ustalenia treści normy wynikającej z interpretowanego postanowienia umownego. W przypadku umowy badanej w niniejszej sprawie jednak Sąd odwoławczy ustalił, że kwestionowane klauzule indeksacyjne dotyczą w równym stopniu wyliczenia samego zobowiązania kredytowego (świadczenia głównego), sposobu kalkulacji należnych rat, jak i naliczania marży. Z tej przyczyny nie znalazł podstaw do wyinterpretowania oddzielnej normy prawnej odnoszącej się wyłącznie do marży banku.” 
          Ponadto zgodnie z postanowieniem Sądu Najwyższego z dnia 18 sierpnia 2023 r., sygn. akt I CSK 4167/22 ,,przedstawione zagadnienie nie wywołuje poważnych wątpliwości, zważywszy wyjaśnienia Trybunału Sprawiedliwości Unii Europejskiej zawarte w wyroku z dnia 29 kwietnia 2021 r., C-19/20, Bank BPH, gdzie Trybunał stwierdził m.in., że przepisy dyrektywy 93/13 stoją na przeszkodzie temu, żeby uznany za nieuczciwy warunek został częściowo utrzymany w mocy przez usunięcie elementów przesądzających o jego nieuczciwym charakterze, w przypadku gdyby to usunięcie sprowadzało się do mającej wpływ na istotę tych warunków zmiany ich treści (pkt 70) i że jedynie wtedy, gdyby element klauzuli indeksacyjnej rozpatrywanego w postępowaniu głównym kredytu hipotecznego dotyczący marży Banku stanowił zobowiązanie umowne odrębne od innych postanowień umownych, które mogłoby być przedmiotem zindywidualizowanego badania jego nieuczciwego charakteru, sąd krajowy mógłby go usunąć” (pkt 71). Nie widać bowiem podstaw do przyjęcia, że postanowienie określające miarodajny kurs waluty jako sumę kursu średniego NBP i marży banku, dotyczy w istocie dwóch odrębnych zobowiązań umownych. W szczególności postanowienie takie różni się zasadniczo od przywołanych w orzeczeniu Trybunału - i uznanych za odrębne - postanowień umowy kredytu dotyczących, odpowiednio, odsetek zwykłych i odsetek za zwłokę (por. też wyrok Trybunału Sprawiedliwości Unii Europejskiej z dnia 7 sierpnia 2018 r., C-96/16 i C-94/17, Banco Santander i Escobedo Cortés, pkt 76-77)” (tak samo: postanowienie Sądu Najwyższego z dnia 20 października I CSK 4949/22).
          Zgadzając się ze wskazanym poglądem dodać można, że mimo różnych sposobów redakcyjnego ujęcia kwestii odwołania do tabeli kursowej wciąż można mówić o jednym tylko świadczeniu kredytodawcy i kredytobiorcy, spełnianych wzajemnie w celu uzyskania świadczenia drugiej strony. Ostatecznie bowiem było przewidziane jedno świadczenie w wysokości wynikającej z tabeli kursowej banku, bez wyodrębnienia świadczenia spełnianego wg średniego kursu NBP i świadczenia stanowiącego marżę banku. Przedstawione ujęcie odpowiada dotychczasowej praktyce orzeczniczej Sądu Najwyższego, który opowiada się za potrzebą kompleksowej oceny klauzuli waloryzacyjnej (zob. wyrok SN z 11 grudnia 2019 r. V CSK 382/18). Przedstawione ujęcie i brak możliwości usunięcia jedynie marży z umowy potwierdza szereg orzeczeń sądów powszechnych (zob. wyroki Sądu Apelacyjnego w Gdańsku z dnia: 9.06.2021 r. V ACa 127/21, 04.02.2022 V ACa 340/21, 19.11.2021 V ACa 256/21, 15.12.2021 I ACa 396/21, z 11.01.2022 I ACa 750/21, 23.11.2021 V ACa 77/21, 15.12.2021 I ACa 396/21; wyroki Sądu Apelacyjnego we Wrocławiu z: 22.04.2022 I ACa 1273/21, 22.02.2022 I ACa 1462/21, 20.01.2022 I ACa 551/21, wyrok Sądu Apelacyjnego w Szczecinie z 28.04.2022 I ACa 887/21, wyrok Sądu Apelacyjnego w Warszawie z 20.04.2022 VI ACa 395/21, wyrok Sądu Apelacyjnego w Poznaniu z 18.02.2022 I ACa 277/21, wyroki Sądu Apelacyjnego w Katowicach z: 07.03.2022 VI ACa 671/21, 21.01.2022 I ACa 248/21.
          Jak trafnie wskazał Sąd Apelacyjny w Katowicach w wyroku z dnia 21 czerwca 2022 r. I ACa 111/22 LEX nr 3370693: „klauzuli indeksacyjnej dotyczącej marży Banku (§ 17 umowy) nie można zakwalifikować jako zobowiązania umownego odrębnego od innych postanowień umownych, ponieważ wykładni ust. 2-4 § 17 umowy nie można dokonywać z pominięciem § 1, zgodnie z którym "do rozliczania transakcji wypłat i spłat kredytów stosowane są odpowiednio kursy kupna/sprzedaży dla kredytów hipotecznych (...) walut zawartych w ofercie Banku obowiązujące w dniu dokonania transakcji", a więc do rozliczenia transakcji wypłaty stosowany był kurs kupna CHF, zaś do rozliczenia spłaty - kurs sprzedaży CHF, co stanowiło ogólną zasadę wynikającą z umowy. (…) W rezultacie, klauzula indeksacyjna w tym wypadku nie tyle kreowała odrębne zobowiązanie, ile stanowiła element precyzujący zobowiązanie w zakresie określenia wysokości świadczenia głównego stron - wysokości wypłaconego kredytu oraz wysokości spłacanych rat. Dodatkowo określony w § 17 mechanizm indeksacyjny uwzględniający także spread walutowy jest ze sobą wewnętrznie powiązany w taki sposób, że wyeliminowanie elementu dotyczącego marży spowodowałby zmianę istoty treści klauzuli indeksacyjnej. Wyeliminowanie elementu dotyczącego marży spowodowałoby bowiem, że kurs kupna i sprzedaży waluty CHF rozumiany byłby wyłącznie jako "średni kurs złotego do danej waluty ogłoszony w tabeli kursów NBP", a taki zabieg stanowiłby zdaniem sądu drugiej instancji niedopuszczalne przeprowadzenie redukcji utrzymującej skuteczność abuzywnej klauzuli waloryzacyjnej, przez podzielenie jej na część wadliwą i dopuszczalną, co zupełnie zmieniałoby sens § 17 umowy, zwłaszcza że mechanizm indeksacyjny należy rozumieć kompleksowo.”
          `
          : "",
        date:
          (new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate()) +
          " " +
          getMonthName(new Date().getMonth() + 1) +
          " " +
          new Date().getFullYear() +
          " r.",
        hasManyPet: getPetitionerData().length > 1 ? true : false,
        hasNManyPet: getPetitionerData().length === 1 ? true : false,
        petitioner_data: generateClientName(),
        petitioner_data2: generateClientName2(),
        pettioner_details:
          "telefon: " +
          props.clientsData.phone +
          ", adres e-mail: " +
          props.clientsData.email,

        bank: bankAddressDb ? bankAddressDb.nameLetter : "",
        bank2:
          bankAddressDb && bankAddressDb !== "undefined"
            ? bankAddressDb.nameLetter
            : props.clientsData.bank,
        bank_address: bankAddressDb ? bankAddressDb.address : "",
        bank_krs: bankAddressDb ? bankAddressDb.bankKRS : "",
        wps_add: true
          ? ""
          : +props.clientsData.wezwChfValue > 0
          ? "\n" +
            "WPS: " +
            numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.wezwPlnValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".") +
                    +props.clientsData.realCreditValue
                      .replaceAll(" ", "")
                      .replaceAll(",", ".")
                ).toFixed(0)
              ).toFixed(2)
            ) +
            " PLN + " +
            numberWithCommas(
              parseFloat(props.clientsData.wezwChfValue).toFixed(2)
            ) +
            " CHF"
          : "",
        wps_sum:
          "WPS: " +
          numberWithCommas(Math.ceil(parseFloat(sum)).toFixed(2)) +
          " PLN",
        date_wym:
          (new Date(props.clientsData.dateWym).getDate() < 10
            ? "0" + new Date(props.clientsData.dateWym).getDate()
            : new Date(props.clientsData.dateWym).getDate()) +
          " " +
          getMonthName(new Date(props.clientsData.dateWym).getMonth() + 1) +
          " " +
          new Date(props.clientsData.dateWym).getFullYear() +
          " r.",
        zab_wn:
          props.clientsData.application_for_protection === "TAK"
            ? "z wnioskiem o zabezpieczenie"
            : "",
        pod_um_kr:
          props.clientsData.bank_old !== ""
            ? `(następcą prawnym: ${props.clientsData.bank_old})`
            : "",
        pod_um_kr_bool: props.clientsData.bank_old !== "" ? true : false,
        bank_pod:
          props.clientsData.bank_old !== ""
            ? props.clientsData.bank_old
            : bankAddressDb
            ? bankAddressDb.nameLetter
            : "",
        creditNumber: props.clientsData.credit_aggr_num,
        real_cr_value: numberWithCommas(
          parseFloat(
            parseFloat(
              props.clientsData.realCreditValue
                ? +props.clientsData.realCreditValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                : 0
            ).toFixed(2)
          ).toFixed(2)
        ),
        curr: curr,
        curr_old: curr_old,
        year_cr_date: new Date(props.clientsData.credit_date).getFullYear(),
        creditDate:
          (new Date(props.clientsData.credit_date).getDate() < 10
            ? "0" + new Date(props.clientsData.credit_date).getDate()
            : new Date(props.clientsData.credit_date).getDate()) +
          " " +
          getMonthName(new Date(props.clientsData.credit_date).getMonth() + 1) +
          " " +
          new Date(props.clientsData.credit_date).getFullYear() +
          " r.",
        zast_text:
          props.clientsData.petitioner.replaceAll("  ", "").split(",").length >
          1
            ? "zastępowani"
            : "zastępowany",
        plnValue: plnValueTr,
        plnText: plnTextTr,
        chfValue:
          +chfValue !== undefined
            ? +chfValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
              ? chfValueTr + " CHF"
              : ""
            : "",
        chfText:
          +chfValue !== undefined
            ? +chfValue.toString().replaceAll(" ", "").replaceAll(",", ".") >
                0 &&
              +plnValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
              ? " oraz "
              : ""
            : "",
        chf_add_text:
          +props.clientsData.wezwChfValue
            .toString()
            .replaceAll(" ", "")
            .replaceAll(",", ".") > 0
            ? "od obu wskazanych kwot"
            : "",
        aggr_points: aggr_points,

        payed_cr: false,
        payed_add_cr: [
          {
            name: "a)",
            value: `oświadczenia o potrąceniu z dnia … r. na okoliczności jego treści, w tym złożenia przez Powoda Pozwanemu oświadczenia o potrąceniu wzajemnych wierzytelności oraz nieistnienia wierzytelności Pozwanego o zwrot kapitału kredytu (kserokopia),`,
          },
          {
            name: "b)",
            value: `potwierdzenia nadania oświadczenia o potrąceniu z dnia … r. na okoliczność skierowania do Pozwanego oświadczenia o potrąceniu (kserokopia),`,
          },
          {
            name: "c)",
            value: `wydruku z elektronicznego systemu śledzenia przesyłek operatora Poczty Polskiej S.A. (emonitoring.poczta-polska.pl) z dnia … r. na okoliczność doręczenia Pozwanemu oświadczenia o potrąceniu (wydruk),`,
          },
        ],

        raiffeisen_text: props.clientsData.bank.includes("Raiffeisen")
          ? [
              {
                name: "a)",
                value: `Umowy kredytu z dnia ${creditDateText} na okoliczność treści praw i obowiązków wynikających z zawartej Umowy (kserokopia),`,
              },
              {
                name: "b)",
                value: `Regulaminu kredytu hipotecznego udzielanego przez Polbank EFG na okoliczność treści praw i obowiązków wynikających z zawartej Umowy i Regulaminu (kserokopia),`,
              },
              {
                name: "c)",
                value: `Zaświadczenia banku z dnia ${
                  props.clientsData.lawZaswDate !== null
                    ? (new Date(props.clientsData.lawZaswDate).getDate() < 10
                        ? "0" +
                          new Date(props.clientsData.lawZaswDate).getDate()
                        : new Date(props.clientsData.lawZaswDate).getDate()) +
                      " " +
                      getMonthName(
                        new Date(props.clientsData.lawZaswDate).getMonth() + 1
                      ) +
                      " " +
                      new Date(props.clientsData.lawZaswDate).getFullYear() +
                      " r."
                    : "(uzupełnij)"
                } na okoliczność jego treści, w tym wypłaty kredytu, wysokości i dat poszczególnych spłat, łącznej wysokości uzyskanych przez Pozwanego od Powoda świadczeń, wysokości oprocentowania (kserokopia),`,
                bo: props.clientsData.lawZaswDate === null ? false : true,
              },
              {
                name: "c)",
                value: `Zaświadczenia banku z dnia ${
                  props.clientsData.lawZaswDate2 !== null
                    ? (new Date(props.clientsData.lawZaswDate2).getDate() < 10
                        ? "0" +
                          new Date(props.clientsData.lawZaswDate2).getDate()
                        : new Date(props.clientsData.lawZaswDate2).getDate()) +
                      " " +
                      getMonthName(
                        new Date(props.clientsData.lawZaswDate2).getMonth() + 1
                      ) +
                      " " +
                      new Date(props.clientsData.lawZaswDate2).getFullYear() +
                      " r."
                    : "(uzupełnij)"
                } na okoliczność jego treści, w tym wypłaty kredytu, wysokości i dat poszczególnych spłat, łącznej wysokości uzyskanych przez Pozwanego od Powoda świadczeń, wysokości oprocentowania (kserokopia),`,
                bo: props.clientsData.lawZaswDate2 === null ? false : true,
              },
              {
                name: "c)",
                value: `Zaświadczenia banku z dnia ${
                  props.clientsData.lawZaswDate3 !== null
                    ? (new Date(props.clientsData.lawZaswDate3).getDate() < 10
                        ? "0" +
                          new Date(props.clientsData.lawZaswDate3).getDate()
                        : new Date(props.clientsData.lawZaswDate3).getDate()) +
                      " " +
                      getMonthName(
                        new Date(props.clientsData.lawZaswDate3).getMonth() + 1
                      ) +
                      " " +
                      new Date(props.clientsData.lawZaswDate3).getFullYear() +
                      " r."
                    : "(uzupełnij)"
                } na okoliczność jego treści, w tym wypłaty kredytu, wysokości i dat poszczególnych spłat, łącznej wysokości uzyskanych przez Pozwanego od Powoda świadczeń, wysokości oprocentowania (kserokopia),`,
                bo: props.clientsData.lawZaswDate3 === null ? false : true,
              },
              {
                name: "d)",
                value: `Wezwania do zapłaty z dnia ${dateWezwTxt} na okoliczność próby polubownego załatwienia sprawy (kserokopia),`,
              },
              {
                name: "e)",
                value: `Potwierdzenia nadania wezwania do zapłaty z dnia ${dateSendTxt} na okoliczność skierowania do Pozwanego przedsądowego wezwania do zapłaty (kserokopia),`,
              },
              {
                name: "f)",
                value: `Wydruku z elektronicznego systemu śledzenia przesyłek operatora Poczty Polskiej S.A. (emonitoring.poczta-polska.pl) z dnia ${datePrintTxt} na okoliczność odebrania przez Pozwanego wezwania do zapłaty oraz daty wymagalności roszczenia o zapłatę (wydruk),`,
              },
            ]
          : "",

        mbank_spl: props.clientsData.bank.includes("mBank")
          ? `Zgodnie z aktualnym stanowiskiem Sądu Najwyższego wyrażonym w postanowienia z dnia 7 lutego 2023 r., sygn. akt: I CSK 4195/22 (www.sn.pl) nie ma możliwości usunięcia części nieuczciwego elementu warunku umowy poprzez wykreślenie ze spornej umowy kredytu § 17 marży kupna/marży sprzedaży. Sąd Najwyższy wskazał, że „z wyroku TSUE wydanego w sprawie C-19/20 nie wynika jednolity sposób traktowania zobowiązania do uiszczenia na rzecz kredytującego banku marży. Zobowiązanie takie wynika bowiem z treści konkretnej umowy zawieranej przez strony i podlega zasadom wykładni oświadczeń woli. Wykładnia ta, dokonywana w każdym przypadku, prowadzi do ustalenia treści normy wynikającej z interpretowanego postanowienia umownego. W przypadku umowy badanej w niniejszej sprawie jednak Sąd odwoławczy ustalił, że kwestionowane klauzule indeksacyjne dotyczą w równym stopniu wyliczenia samego zobowiązania kredytowego (świadczenia głównego), sposobu kalkulacji należnych rat, jak i naliczania marży. Z tej przyczyny nie znalazł podstaw do wyinterpretowania oddzielnej normy prawnej odnoszącej się wyłącznie do marży banku.”
          Zgadzając się ze wskazanym poglądem dodać można, że mimo różnych sposobów redakcyjnego ujęcia kwestii odwołania do tabeli kursowej wciąż można mówić o jednym tylko świadczeniu kredytodawcy i kredytobiorcy, spełnianych wzajemnie w celu uzyskania świadczenia drugiej strony. Ostatecznie bowiem było przewidziane jedno świadczenie w wysokości wynikającej z tabeli kursowej banku, bez wyodrębnienia świadczenia spełnianego wg średniego kursu NBP i świadczenia stanowiącego marżę banku. Przedstawione ujęcie odpowiada dotychczasowej praktyce orzeczniczej Sądu Najwyższego, który opowiada się za potrzebą kompleksowej oceny klauzuli waloryzacyjnej (zob. wyrok SN z 11 grudnia 2019 r. V CSK 382/18). Przedstawione ujęcie i brak możliwości usunięcia jedynie marży z umowy potwierdza szereg orzeczeń sądów powszechnych (zob. wyroki Sądu Apelacyjnego w Gdańsku z dnia: 9.06.2021 r. V ACa 127/21, 04.02.2022 V ACa 340/21, 19.11.2021 V ACa 256/21, 15.12.2021 I ACa 396/21, z 11.01.2022 I ACa 750/21, 23.11.2021 V ACa 77/21, 15.12.2021 I ACa 396/21; wyroki Sądu Apelacyjnego we Wrocławiu z: 22.04.2022 I ACa 1273/21, 22.02.2022 I ACa 1462/21, 20.01.2022 I ACa 551/21, wyrok Sądu Apelacyjnego w Szczecinie z 28.04.2022 I ACa 887/21, wyrok Sądu Apelacyjnego w Warszawie z 20.04.2022 VI ACa 395/21, wyrok Sądu Apelacyjnego w Poznaniu z 18.02.2022 I ACa 277/21, wyroki Sądu Apelacyjnego w Katowicach z: 07.03.2022 VI ACa 671/21, 21.01.2022 I ACa 248/21.
          Jak trafnie wskazał Sąd Apelacyjny w Katowicach w wyroku z dnia 21 czerwca 2022 r. I ACa 111/22 LEX nr 3370693: „klauzuli indeksacyjnej dotyczącej marży Banku (§ 17 umowy) nie można zakwalifikować jako zobowiązania umownego odrębnego od innych postanowień umownych, ponieważ wykładni ust. 2-4 § 17 umowy nie można dokonywać z pominięciem § 1, zgodnie z którym "do rozliczania transakcji wypłat i spłat kredytów stosowane są odpowiednio kursy kupna/sprzedaży dla kredytów hipotecznych (...) walut zawartych w ofercie Banku obowiązujące w dniu dokonania transakcji", a więc do rozliczenia transakcji wypłaty stosowany był kurs kupna CHF, zaś do rozliczenia spłaty - kurs sprzedaży CHF, co stanowiło ogólną zasadę wynikającą z umowy. (…) W rezultacie, klauzula indeksacyjna w tym wypadku nie tyle kreowała odrębne zobowiązanie, ile stanowiła element precyzujący zobowiązanie w zakresie określenia wysokości świadczenia głównego stron - wysokości wypłaconego kredytu oraz wysokości spłacanych rat. Dodatkowo określony w § 17 mechanizm indeksacyjny uwzględniający także spread walutowy jest ze sobą wewnętrznie powiązany w taki sposób, że wyeliminowanie elementu dotyczącego marży spowodowałby zmianę istoty treści klauzuli indeksacyjnej. Wyeliminowanie elementu dotyczącego marży spowodowałoby bowiem, że kurs kupna i sprzedaży waluty CHF rozumiany byłby wyłącznie jako "średni kurs złotego do danej waluty ogłoszony w tabeli kursów NBP", a taki zabieg stanowiłby zdaniem sądu drugiej instancji niedopuszczalne przeprowadzenie redukcji utrzymującej skuteczność abuzywnej klauzuli waloryzacyjnej, przez podzielenie jej na część wadliwą i dopuszczalną, co zupełnie zmieniałoby sens § 17 umowy, zwłaszcza że mechanizm indeksacyjny należy rozumieć kompleksowo.” 
          `
          : "",
        normal_text:
          !props.clientsData.bank.includes("Raiffeisen") &&
          !props.clientsData.bank.includes("mBank")
            ? [
                {
                  name: "a)",
                  value: `Umowy kredytu z dnia ${creditDateText} na okoliczność treści praw i obowiązków wynikających z zawartej Umowy (kserokopia),`,
                  bo: true,
                },
                {
                  name: "c)",
                  value: `Zaświadczenia banku z dnia ${
                    props.clientsData.lawZaswDate !== null
                      ? (new Date(props.clientsData.lawZaswDate).getDate() < 10
                          ? "0" +
                            new Date(props.clientsData.lawZaswDate).getDate()
                          : new Date(props.clientsData.lawZaswDate).getDate()) +
                        " " +
                        getMonthName(
                          new Date(props.clientsData.lawZaswDate).getMonth() + 1
                        ) +
                        " " +
                        new Date(props.clientsData.lawZaswDate).getFullYear() +
                        " r."
                      : "(uzupełnij)"
                  } na okoliczność jego treści, w tym wypłaty kredytu, wysokości i dat poszczególnych spłat, łącznej wysokości uzyskanych przez Pozwanego od Powoda świadczeń, wysokości oprocentowania (kserokopia),`,
                  bo: props.clientsData.lawZaswDate === null ? false : true,
                },
                {
                  name: "c)",
                  value: `Zaświadczenia banku z dnia ${
                    props.clientsData.lawZaswDate2 !== null
                      ? (new Date(props.clientsData.lawZaswDate2).getDate() < 10
                          ? "0" +
                            new Date(props.clientsData.lawZaswDate2).getDate()
                          : new Date(
                              props.clientsData.lawZaswDate2
                            ).getDate()) +
                        " " +
                        getMonthName(
                          new Date(props.clientsData.lawZaswDate2).getMonth() +
                            1
                        ) +
                        " " +
                        new Date(props.clientsData.lawZaswDate2).getFullYear() +
                        " r."
                      : "(uzupełnij)"
                  } na okoliczność jego treści, w tym wypłaty kredytu, wysokości i dat poszczególnych spłat, łącznej wysokości uzyskanych przez Pozwanego od Powoda świadczeń, wysokości oprocentowania (kserokopia),`,
                  bo: props.clientsData.lawZaswDate2 === null ? false : true,
                },
                {
                  name: "c)",
                  value: `Zaświadczenia banku z dnia ${
                    props.clientsData.lawZaswDate3 !== null
                      ? (new Date(props.clientsData.lawZaswDate3).getDate() < 10
                          ? "0" +
                            new Date(props.clientsData.lawZaswDate3).getDate()
                          : new Date(
                              props.clientsData.lawZaswDate3
                            ).getDate()) +
                        " " +
                        getMonthName(
                          new Date(props.clientsData.lawZaswDate3).getMonth() +
                            1
                        ) +
                        " " +
                        new Date(props.clientsData.lawZaswDate3).getFullYear() +
                        " r."
                      : "(uzupełnij)"
                  } na okoliczność jego treści, w tym wypłaty kredytu, wysokości i dat poszczególnych spłat, łącznej wysokości uzyskanych przez Pozwanego od Powoda świadczeń, wysokości oprocentowania (kserokopia),`,
                  bo: props.clientsData.lawZaswDate3 === null ? false : true,
                },
                {
                  name: "d)",
                  value: `Wezwania do zapłaty z dnia ${dateWezwTxt} na okoliczność próby polubownego załatwienia sprawy (kserokopia),`,
                  bo: true,
                },
                {
                  name: "e)",
                  value: `Potwierdzenia nadania wezwania do zapłaty z dnia ${dateSendTxt} na okoliczność skierowania do Pozwanego przedsądowego wezwania do zapłaty (kserokopia),`,
                  bo: true,
                },
                {
                  name: "f)",
                  value: `Wydruku z elektronicznego systemu śledzenia przesyłek operatora Poczty Polskiej S.A. (emonitoring.poczta-polska.pl) z dnia ${datePrintTxt} na okoliczność odebrania przez Pozwanego wezwania do zapłaty oraz daty wymagalności roszczenia o zapłatę (wydruk),`,
                  bo: true,
                },
              ]
            : "",

        mbank_text: props.clientsData.bank.includes("mBank")
          ? [
              {
                name: "a)",
                value: `Umowy kredytu z dnia ${creditDateText} na okoliczność treści praw i obowiązków wynikających z zawartej Umowy (kserokopia),`,
                bo: true,
              },
              {
                name: "c)",
                value: `Zaświadczenia banku z dnia ${
                  props.clientsData.lawZaswDate !== null
                    ? (new Date(props.clientsData.lawZaswDate).getDate() < 10
                        ? "0" +
                          new Date(props.clientsData.lawZaswDate).getDate()
                        : new Date(props.clientsData.lawZaswDate).getDate()) +
                      " " +
                      getMonthName(
                        new Date(props.clientsData.lawZaswDate).getMonth() + 1
                      ) +
                      " " +
                      new Date(props.clientsData.lawZaswDate).getFullYear() +
                      " r."
                    : "(uzupełnij)"
                } na okoliczność jego treści, w tym wypłaty kredytu, wysokości i dat poszczególnych spłat, łącznej wysokości uzyskanych przez Pozwanego od Powoda świadczeń, wysokości oprocentowania (kserokopia),`,
                bo: props.clientsData.lawZaswDate === null ? false : true,
              },
              {
                name: "c)",
                value: `Zaświadczenia banku z dnia ${
                  props.clientsData.lawZaswDate2 !== null
                    ? (new Date(props.clientsData.lawZaswDate2).getDate() < 10
                        ? "0" +
                          new Date(props.clientsData.lawZaswDate2).getDate()
                        : new Date(props.clientsData.lawZaswDate2).getDate()) +
                      " " +
                      getMonthName(
                        new Date(props.clientsData.lawZaswDate2).getMonth() + 1
                      ) +
                      " " +
                      new Date(props.clientsData.lawZaswDate2).getFullYear() +
                      " r."
                    : "(uzupełnij)"
                } na okoliczność jego treści, w tym wypłaty kredytu, wysokości i dat poszczególnych spłat, łącznej wysokości uzyskanych przez Pozwanego od Powoda świadczeń, wysokości oprocentowania (kserokopia),`,
                bo: props.clientsData.lawZaswDate2 === null ? false : true,
              },
              {
                name: "c)",
                value: `Zaświadczenia banku z dnia ${
                  props.clientsData.lawZaswDate3 !== null
                    ? (new Date(props.clientsData.lawZaswDate3).getDate() < 10
                        ? "0" +
                          new Date(props.clientsData.lawZaswDate3).getDate()
                        : new Date(props.clientsData.lawZaswDate3).getDate()) +
                      " " +
                      getMonthName(
                        new Date(props.clientsData.lawZaswDate3).getMonth() + 1
                      ) +
                      " " +
                      new Date(props.clientsData.lawZaswDate3).getFullYear() +
                      " r."
                    : "(uzupełnij)"
                } na okoliczność jego treści, w tym wypłaty kredytu, wysokości i dat poszczególnych spłat, łącznej wysokości uzyskanych przez Pozwanego od Powoda świadczeń, wysokości oprocentowania (kserokopia),`,
                bo: props.clientsData.lawZaswDate3 === null ? false : true,
              },
              {
                name: "f)",
                value: `Wezwania do zapłaty z dnia ${dateWezwTxt} na okoliczność próby polubownego załatwienia sprawy (kserokopia),\nh) Potwierdzenia nadania wezwania do zapłaty z dnia ${dateSendTxt} na okoliczność skierowania do Pozwanego przedsądowego wezwania do zapłaty (kserokopia),`,
                bo: true,
              },
              {
                name: "g)",
                value: `Wydruku z elektronicznego systemu śledzenia przesyłek operatora Poczty Polskiej S.A. (emonitoring.poczta-polska.pl) z dnia ${datePrintTxt} na okoliczność odebrania przez Pozwanego wezwania do zapłaty oraz daty wymagalności roszczenia o zapłatę (wydruk),`,
                bo: true,
              },
            ]
          : "",

        date_wezw:
          (new Date(props.clientsData.data_wezw).getDate() < 10
            ? "0" + new Date(props.clientsData.data_wezw).getDate()
            : new Date(props.clientsData.data_wezw).getDate()) +
          " " +
          getMonthName(new Date(props.clientsData.data_wezw).getMonth() + 1) +
          " " +
          new Date(props.clientsData.data_wezw).getFullYear() +
          " r.",
        hasZab:
          props.clientsData.application_for_protection === "TAK" ? true : false,
        wn_zab_text:
          props.clientsData.application_for_protection === "TAK"
            ? `na podstawie art. 730 § 2 KPC w zw. z art. 730(1) KPC wnoszę o udzielenie zabezpieczenia roszczenia Powoda o ustalenie, tj. w zakresie pkt 1 powyżej, poprzez unormowanie praw i obowiązków stron postępowania na czas jego trwania poprzez:`
            : "",
        wn_zab_text2:
          props.clientsData.application_for_protection === "TAK"
            ? [
                {
                  name: "a)",
                  value: `wstrzymanie obowiązku dokonywania spłaty rat kredytu przez Powoda, w wysokości i terminach określonych umową, w okresie od dnia udzielenia zabezpieczenia do dnia uprawomocnienia się orzeczenia w niniejszej sprawie,`,
                },
                {
                  name: "b)",
                  value: `zakazanie pozwanemu Bankowi złożenia Powodowi oświadczenia o wypowiedzeniu Umowy kredytu hipotecznego zastrzeżonego w sytuacji uchybienia terminom płatności rat kredytu – w okresie od dnia udzielenia zabezpieczenia do dnia uprawomocnienia się orzeczenia w niniejszej sprawie,`,
                },
                {
                  name: "c)",
                  value: `zakazanie pozwanemu Bankowi dokonywania wpisów w rejestrach prowadzonych przez Biuro Informacji Kredytowej SA oraz przez biura informacji gospodarczej o zadłużeniu lub zaległościach z tytułu spłat ww. umowy kredytu w okresie od dnia udzielenia zabezpieczenia do dnia uprawomocnienia się orzeczenia w niniejszej sprawie.`,
                },
              ]
            : "",
        date_dor_wezw:
          (new Date(props.clientsData.dateDeliverWezw).getDate() < 10
            ? "0" + new Date(props.clientsData.dateDeliverWezw).getDate()
            : new Date(props.clientsData.dateDeliverWezw).getDate()) +
          " " +
          getMonthName(
            new Date(props.clientsData.dateDeliverWezw).getMonth() + 1
          ) +
          " " +
          new Date(props.clientsData.dateDeliverWezw).getFullYear() +
          " r.",
        pay_time: props.clientsData.wezwPayTime.replaceAll(" dni", ""),
        date_wym_sub:
          (new Date(subDay(props.clientsData.dateWym)).getDate() < 10
            ? "0" + new Date(subDay(props.clientsData.dateWym)).getDate()
            : new Date(subDay(props.clientsData.dateWym)).getDate()) +
          " " +
          getMonthName(
            new Date(subDay(props.clientsData.dateWym)).getMonth() + 1
          ) +
          " " +
          new Date(subDay(props.clientsData.dateWym)).getFullYear() +
          " r.",
        credit_value: creditValueText,
        chf_credit_value_text0:
          props.clientsData.credit_value.split(" ")[1] === "PLN" &&
          (+props.clientsData.wezwChfValue
            .replaceAll(" ", "")
            .replaceAll(",", ".") === undefined ||
            +props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === 0) &&
          +props.clientsData.wezwPlnValue
            .replaceAll(" ", "")
            .replaceAll(",", ".") > 0
            ? `WPS obliczono jako sumę żądania głównego o zapłatę i o ustalenie, przy czym jako wartość żądania o ustalenie przyjęto kwotę kredytu, zaokrąglając do pełnych złotych (${numberWithCommas(
                parseFloat(
                  parseFloat(
                    props.clientsData.credit_value
                      .replaceAll(" ", "")
                      .replaceAll("CHF", "")
                      .replaceAll("PLN", "")
                  ).toFixed(2)
                ).toFixed(2)
              )} PLN + ${plnValueTr} PLN).`
            : "",
        chf_credit_value_text:
          props.clientsData.credit_value.split(" ")[1] === "PLN" &&
          +props.clientsData.wezwChfValue
            .replaceAll(" ", "")
            .replaceAll(",", ".") > 0 &&
          +props.clientsData.wezwPlnValue
            .replaceAll(" ", "")
            .replaceAll(",", ".") > 0
            ? `WPS obliczono jako sumę żądania głównego o zapłatę i o ustalenie, przy czym jako wartość żądania o ustalenie przyjęto kwotę kredytu, a kwotę w CHF przeliczono na PLN wg kursu średniego CHF na dzień sporządzenia pozwu (${numberWithCommas(
                parseFloat(
                  parseFloat(
                    props.clientsData.credit_value
                      .replaceAll(" ", "")
                      .replaceAll("CHF", "")
                      .replaceAll("PLN", "")
                  ).toFixed(2)
                ).toFixed(2)
              )} PLN + ${plnValueTr} PLN + ${chfValueTr} CHF x ${curr}), zaokrąglając następnie do pełnych złotych.`
            : "",
        chf_credit_value_text2: props.clientsData.realCreditValue
          ? +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0
          : false &&
            +props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") !== undefined &&
            (+props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === undefined ||
              +props.clientsData.wezwChfValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") === 0)
          ? `WPS obliczono jako sumę żądania głównego o zapłatę i o ustalenie, przy czym jako wartość żądania o ustalenie przyjęto kwotę rzeczywiście wypłaconego kredytu, zaokrąglając do pełnych złotych (${numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.realCreditValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )} PLN + ${numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.wezwPlnValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )} PLN).`
          : "",
        chf_credit_value_text3: props.clientsData.realCreditValue
          ? +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0
          : false &&
            +props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") !== undefined &&
            +props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") !== undefined &&
            +props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0
          ? `WPS obliczono jako sumę żądań głównych o zapłatę i o ustalenie, przy czym jako wartość żądania o ustalenie przyjęto kwotę rzeczywiście wypłaconego kredytu, tj. ${numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.realCreditValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )} PLN, a kwotę żądania wyrażonego w CHF przeliczono na PLN wg kursu średniego CHF na dzień sporządzenia pozwu (${numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.wezwPlnValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )} PLN + ${numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.wezwChfValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )} CHF x ${curr} + ${numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.realCreditValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )} PLN), zaokrąglając następnie do pełnych złotych.`
          : "",
        chf_credit_value_text4: props.clientsData.realCreditValue
          ? +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === undefined ||
            +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === 0
          : false &&
            +props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") !== undefined &&
            +props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0 &&
            +props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") !== undefined &&
            +props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") > 0
          ? `WPS obliczono jako sumę żądania głównego o zapłatę i o ustalenie, przy czym jako wartość żądania o ustalenie przyjęto kwotę kredytu, tj. ${numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.credit_value
                    .split(" ")[0]
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )} CHF. Kwotę kredytu i roszczenie wyrażone w CHF Powód przeliczył na PLN wg kursu średniego CHF na dzień sporządzenia pozwu (${numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.wezwPlnValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )} PLN + ${numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.wezwChfValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )} CHF x ${curr} + ${numberWithCommas(
              parseFloat(
                parseFloat(
                  props.clientsData.credit_value
                    .replaceAll("CHF", "")
                    .replaceAll("PLN", "")
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )} CHF x ${curr}), zaokrąglając następnie do pełnych złotych.`
          : "",
        chf_credit_value_text5: props.clientsData.realCreditValue
          ? +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === undefined ||
            +props.clientsData.realCreditValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === 0
          : false &&
            (+props.clientsData.wezwPlnValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") !== undefined ||
              +props.clientsData.wezwPlnValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") > 0) &&
            (+props.clientsData.wezwChfValue
              .replaceAll(" ", "")
              .replaceAll(",", ".") === undefined ||
              +props.clientsData.wezwChfValue
                .replaceAll(" ", "")
                .replaceAll(",", ".") === 0)
          ? `WPS obliczono jako sumę żądania głównego o zapłatę i o ustalenie, przy czym jako wartość żądania o ustalenie przyjęto kwotę kredytu, tj. ${numberWithCommas(
              parseFloat(
                parseFloat(
                  props.clientsData.credit_value
                    .replaceAll("CHF", "")
                    .replaceAll("PLN", "")
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )} CHF. Roszczenie wyrażone w CHF Powód przeliczył na PLN wg kursu średniego CHF na dzień sporządzenia pozwu (${numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.wezwPlnValue
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )} PLN + ${numberWithCommas(
              parseFloat(
                parseFloat(
                  +props.clientsData.credit_value
                    .replaceAll("CHF", "")
                    .replaceAll("PLN", "")
                    .replaceAll(" ", "")
                    .replaceAll(",", ".")
                ).toFixed(2)
              ).toFixed(2)
            )} CHF x ${curr}), zaokrąglając następnie do pełnych złotych.`
          : "",
        last_pay_date: props.clientsData.wezwLastPayDate,
        aggr_bank: props.clientsData.bank,
        raiffeisen_text_2: props.clientsData.bank.includes("Raiffeisen")
          ? [
              {
                name: "a)",
                value: `Odpis pełnomocnictwa z dowodem uiszczenia opłaty skarbowej,`,
                bo: true,
              },
              {
                name: "b)",
                value: `Umowa kredytu z dnia ${creditDateText} (kserokopia),`,
                bo: true,
              },
              {
                name: "c)",
                value: `Regulamin kredytu hipotecznego udzielanego przez Polbank EFG (kserokopia),`,
                bo: true,
              },
              {
                name: "d)",
                value: `Zaświadczenie banku z dnia ${
                  props.clientsData.lawZaswDate !== undefined &&
                  props.clientsData.lawZaswDate !== null
                    ? (new Date(props.clientsData.lawZaswDate).getDate() < 10
                        ? "0" +
                          new Date(props.clientsData.lawZaswDate).getDate()
                        : new Date(props.clientsData.lawZaswDate).getDate()) +
                      " " +
                      getMonthName(
                        new Date(props.clientsData.lawZaswDate).getMonth() + 1
                      ) +
                      " " +
                      new Date(props.clientsData.lawZaswDate).getFullYear() +
                      " r."
                    : "(uzupełnij)"
                } (kserokopia),`,
                bo: true,
              },
              {
                name: "c)",
                value: `Zaświadczenia banku z dnia ${
                  props.clientsData.lawZaswDate2 !== undefined &&
                  props.clientsData.lawZaswDate2 !== null
                    ? (new Date(props.clientsData.lawZaswDate2).getDate() < 10
                        ? "0" +
                          new Date(props.clientsData.lawZaswDate2).getDate()
                        : new Date(props.clientsData.lawZaswDate2).getDate()) +
                      " " +
                      getMonthName(
                        new Date(props.clientsData.lawZaswDate2).getMonth() + 1
                      ) +
                      " " +
                      new Date(props.clientsData.lawZaswDate2).getFullYear() +
                      " r."
                    : "(uzupełnij)"
                } (kserokopia),`,
                bo:
                  props.clientsData.lawZaswDate2 !== undefined &&
                  props.clientsData.lawZaswDate2 !== null
                    ? true
                    : false,
              },
              {
                name: "c)",
                value: `Zaświadczenia banku z dnia ${
                  props.clientsData.lawZaswDate3 !== undefined &&
                  props.clientsData.lawZaswDate3 !== null
                    ? (new Date(props.clientsData.lawZaswDate3).getDate() < 10
                        ? "0" +
                          new Date(props.clientsData.lawZaswDate3).getDate()
                        : new Date(props.clientsData.lawZaswDate3).getDate()) +
                      " " +
                      getMonthName(
                        new Date(props.clientsData.lawZaswDate3).getMonth() + 1
                      ) +
                      " " +
                      new Date(props.clientsData.lawZaswDate3).getFullYear() +
                      " r."
                    : "(uzupełnij)"
                } (kserokopia),`,
                bo:
                  props.clientsData.lawZaswDate2 !== undefined &&
                  props.clientsData.lawZaswDate2 !== null
                    ? true
                    : false,
              },
              {
                name: "e)",
                value: `Wezwanie do zapłaty z dnia ${dateWezwTxt} (kserokopia),`,
                bo: true,
              },
              {
                name: "f)",
                value: `Potwierdzenie nadania wezwania do zapłaty z dnia ${dateSendTxt} (kserokopia),`,
                bo: true,
              },
              {
                name: "g)",
                value: `Wydruk z elektronicznego systemu śledzenia przesyłek operatora Poczty Polskiej S.A. (emonitoring.poczta-polska.pl) z dnia ${datePrintTxt} (wydruk),`,
                bo: true,
              },
              {
                name: "h)",
                value: `Oświadczenie o potrąceniu z dnia … r. (kserokopia),`,
                bo: false,
              },
              {
                name: "i)",
                value: `Potwierdzenie nadania oświadczenia o potrąceniu z dnia … r. (kserokopia),`,
                bo: false,
              },
              {
                name: "j)",
                value: `Wydruk z elektronicznego systemu śledzenia przesyłek operatora Poczty Polskiej S.A. (emonitoring.poczta-polska.pl) z dnia … r. (wydruk)`,
                bo: false,
              },
              {
                name: "k)",
                value: `Dowód uiszczenia opłaty sądowej,`,
                bo: true,
              },
              {
                name: "l)",
                value: `Odpis pozwu dla doręczenia Pozwanemu.`,
                bo: true,
              },
            ]
          : "",
        mbank_text_2: props.clientsData.bank.includes("mBank")
          ? [
              {
                name: "a)",
                value: `Odpis pełnomocnictwa z dowodem uiszczenia opłaty skarbowej,`,
                bo: true,
              },
              {
                name: "b)",
                value: `Umowa kredytu z dnia ${creditDateText} (kserokopia),`,
                bo: true,
              },
              {
                name: "c)",
                value: `Zaświadczenie banku z dnia ${
                  props.clientsData.lawZaswDate !== undefined &&
                  props.clientsData.lawZaswDate !== null
                    ? (new Date(props.clientsData.lawZaswDate).getDate() < 10
                        ? "0" +
                          new Date(props.clientsData.lawZaswDate).getDate()
                        : new Date(props.clientsData.lawZaswDate).getDate()) +
                      " " +
                      getMonthName(
                        new Date(props.clientsData.lawZaswDate).getMonth() + 1
                      ) +
                      " " +
                      new Date(props.clientsData.lawZaswDate).getFullYear() +
                      " r."
                    : "(uzupełnij)"
                } (kserokopia),`,
                bo: true,
              },
              props.clientsData.lawZaswDate2
                ? {
                    name: "c)",
                    value: `Zaświadczenia banku z dnia ${
                      props.clientsData.lawZaswDate2 !== undefined &&
                      props.clientsData.lawZaswDate2 !== null
                        ? (new Date(props.clientsData.lawZaswDate2).getDate() <
                          10
                            ? "0" +
                              new Date(props.clientsData.lawZaswDate2).getDate()
                            : new Date(
                                props.clientsData.lawZaswDate2
                              ).getDate()) +
                          " " +
                          getMonthName(
                            new Date(
                              props.clientsData.lawZaswDate2
                            ).getMonth() + 1
                          ) +
                          " " +
                          new Date(
                            props.clientsData.lawZaswDate2
                          ).getFullYear() +
                          " r."
                        : "(uzupełnij)"
                    } (kserokopia),`,
                  }
                : {},
              props.clientsData.lawZaswDate3
                ? {
                    name: "c)",
                    value: `Zaświadczenia banku z dnia ${
                      props.clientsData.lawZaswDate3 !== undefined &&
                      props.clientsData.lawZaswDate3 !== null
                        ? (new Date(props.clientsData.lawZaswDate3).getDate() <
                          10
                            ? "0" +
                              new Date(props.clientsData.lawZaswDate3).getDate()
                            : new Date(
                                props.clientsData.lawZaswDate3
                              ).getDate()) +
                          " " +
                          getMonthName(
                            new Date(
                              props.clientsData.lawZaswDate3
                            ).getMonth() + 1
                          ) +
                          " " +
                          new Date(
                            props.clientsData.lawZaswDate3
                          ).getFullYear() +
                          " r."
                        : "(uzupełnij)"
                    } (kserokopia),`,
                  }
                : {},
              {
                name: "g)",
                value: `Wezwanie do zapłaty z dnia ${dateWezwTxt} (kserokopia),`,
                bo: true,
              },
              {
                name: "h)",
                value: `Potwierdzenie nadania wezwania do zapłaty z dnia ${dateSendTxt} (kserokopia),`,
                bo: true,
              },
              {
                name: "i)",
                value: `Wydruk z elektronicznego systemu śledzenia przesyłek operatora Poczty Polskiej S.A. (emonitoring.poczta-polska.pl) z dnia ${datePrintTxt} (wydruk),`,
                bo: true,
              },
              {
                name: "h)",
                value: `Oświadczenie o potrąceniu z dnia … r. (kserokopia),`,
                bo: false,
              },
              {
                name: "i)",
                value: `Potwierdzenie nadania oświadczenia o potrąceniu z dnia … r. (kserokopia),`,
                bo: false,
              },
              {
                name: "j)",
                value: `Wydruk z elektronicznego systemu śledzenia przesyłek operatora Poczty Polskiej S.A. (emonitoring.poczta-polska.pl) z dnia … r. (wydruk)`,
                bo: false,
              },
              {
                name: "k)",
                value: `Dowód uiszczenia opłaty sądowej,`,
                bo: true,
              },
              {
                name: "l)",
                value: `Odpis pozwu dla doręczenia Pozwanemu.`,
                bo: true,
              },
            ]
          : "",
        normal_text_2:
          !props.clientsData.bank.includes("Raiffeisen") &&
          !props.clientsData.bank.includes("mBank")
            ? [
                {
                  name: "a)",
                  value: `Odpis pełnomocnictwa z dowodem uiszczenia opłaty skarbowej,`,
                  bo: true,
                },
                {
                  name: "b)",
                  value: `Umowa kredytu z dnia ${creditDateText} (kserokopia),`,
                  bo: true,
                },
                {
                  name: "c)",
                  value: `Zaświadczenie banku z dnia ${
                    props.clientsData.lawZaswDate !== undefined &&
                    props.clientsData.lawZaswDate !== null
                      ? (new Date(props.clientsData.lawZaswDate).getDate() < 10
                          ? "0" +
                            new Date(props.clientsData.lawZaswDate).getDate()
                          : new Date(props.clientsData.lawZaswDate).getDate()) +
                        " " +
                        getMonthName(
                          new Date(props.clientsData.lawZaswDate).getMonth() + 1
                        ) +
                        " " +
                        new Date(props.clientsData.lawZaswDate).getFullYear() +
                        " r."
                      : "(uzupełnij)"
                  } (kserokopia),`,
                  bo: true,
                },
                {
                  name: "c)",
                  value: `Zaświadczenia banku z dnia ${
                    props.clientsData.lawZaswDate2 !== undefined &&
                    props.clientsData.lawZaswDate2 !== null
                      ? (new Date(props.clientsData.lawZaswDate2).getDate() < 10
                          ? "0" +
                            new Date(props.clientsData.lawZaswDate2).getDate()
                          : new Date(
                              props.clientsData.lawZaswDate2
                            ).getDate()) +
                        " " +
                        getMonthName(
                          new Date(props.clientsData.lawZaswDate2).getMonth() +
                            1
                        ) +
                        " " +
                        new Date(props.clientsData.lawZaswDate2).getFullYear() +
                        " r."
                      : "(uzupełnij)"
                  } (kserokopia),`,
                  bo:
                    props.clientsData.lawZaswDate2 !== undefined &&
                    props.clientsData.lawZaswDate2 !== null
                      ? true
                      : false,
                },
                {
                  name: "c)",
                  value: `Zaświadczenia banku z dnia ${
                    props.clientsData.lawZaswDate3 !== undefined &&
                    props.clientsData.lawZaswDate3 !== null
                      ? (new Date(props.clientsData.lawZaswDate3).getDate() < 10
                          ? "0" +
                            new Date(props.clientsData.lawZaswDate3).getDate()
                          : new Date(
                              props.clientsData.lawZaswDate3
                            ).getDate()) +
                        " " +
                        getMonthName(
                          new Date(props.clientsData.lawZaswDate3).getMonth() +
                            1
                        ) +
                        " " +
                        new Date(props.clientsData.lawZaswDate3).getFullYear() +
                        " r."
                      : "(uzupełnij)"
                  } (kserokopia),`,
                  bo:
                    props.clientsData.lawZaswDate3 !== undefined &&
                    props.clientsData.lawZaswDate3 !== null
                      ? true
                      : false,
                },
                {
                  name: "d)",
                  value: `Wezwanie do zapłaty z dnia ${dateWezwTxt} (kserokopia),`,
                  bo: true,
                },
                {
                  name: "e)",
                  value: `Potwierdzenie nadania wezwania do zapłaty z dnia ${dateSendTxt} (kserokopia),`,
                  bo: true,
                },
                {
                  name: "f)",
                  value: `Wydruk z elektronicznego systemu śledzenia przesyłek operatora Poczty Polskiej S.A. (emonitoring.poczta-polska.pl) z dnia ${datePrintTxt} (wydruk),`,
                  bo: true,
                },
                {
                  name: "h)",
                  value: `Oświadczenie o potrąceniu z dnia … r. (kserokopia),`,
                  bo: false,
                },
                {
                  name: "i)",
                  value: `Potwierdzenie nadania oświadczenia o potrąceniu z dnia … r. (kserokopia),`,
                  bo: false,
                },
                {
                  name: "j)",
                  value: `Wydruk z elektronicznego systemu śledzenia przesyłek operatora Poczty Polskiej S.A. (emonitoring.poczta-polska.pl) z dnia … r. (wydruk)`,
                  bo: false,
                },
                {
                  name: "h)",
                  value: `Dowód uiszczenia opłaty sądowej,`,
                  bo: true,
                },
                {
                  name: "i)",
                  value: `Odpis pozwu dla doręczenia Pozwanemu.`,
                  bo: true,
                },
              ]
            : "",
      });
      try {
        doc.render();
      } catch (error) {
        function replaceErrors(key, value) {
          if (value instanceof Error) {
            return Object.getOwnPropertyNames(value).reduce(function (
              error,
              key
            ) {
              error[key] = value[key];
              return error;
            },
            {});
          }
          return value;
        }

        if (error.properties && error.properties.errors instanceof Array) {
          const errorMessages = error.properties.errors
            .map(function (error) {
              return error.properties.explanation;
            })
            .join("\n");
        }
        throw error;
      }
      var out = doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      saveAs(
        out,
        getTemplateName(template) + "_" + props.clientsData.petitioner
      );
      MySwal.fire({
        title: "Czy chcesz zapisać pismo w systemie?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          let formData = new FormData();
          formData.append("file", out);
          formData.append("type", "auto");
          formData.append("clientId", props.clientsData.id);
          formData.append("taskId", "");
          formData.append("user", props.userName);
          formData.append(
            "name",
            getTemplateName(template) + "_" + props.clientsData.petitioner
          );

          await fetch("https://apidevkppp.ftpeople.pl/uploadFileAuto", {
            method: "POST",
            body: formData,
          })
            .then((response) => {
              addTask();
            })
            .then((responseJson) => {});
        } else if (result.isDenied) {
          addTask();
        }
      });
    });
  };

  const checkHoliday = (responsible, date) => {
    var final_date = new Date(date);
    var blocks = holidays.filter((el) => el.user === responsible);
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (final_date >= el.date_from && final_date <= el.date_to) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const addDayOne = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 1));
    return retDate;
  };

  const addTask = () => {
    MySwal.fire({
      title: "Czy chcesz dodać zadanie?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        var date_added =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate() +
          " " +
          new Date().getHours() +
          ":" +
          new Date().getMinutes();

        var date_start =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate();

        var date_final = new Date();

        while (
          (checkFree(date_final) ||
            checkHoliday(props.user.name, date_final)) &&
          (date_final.getDay() === 0 || date_final.getDay() === 6)
        ) {
          date_final = addDayOne(date_final);
        }

        var dateFinal =
          date_final.getFullYear() +
          "-" +
          (date_final.getMonth() + 1) +
          "-" +
          date_final.getDate();

        var toAdd = [];

        var body = {
          start_date: date_start,
          final_date: dateFinal,
          bank: props.clientsData.bank,
          sygn: props.clientsData.aSygn,
          responsible: props.userName,
          client_name: props.clientsData.petitioner,
          task: task,
          date_added: date_added,
          user_added: props.userName,
          status: "WYKONANE",
          court: props.clientsData.newCourt,
          type: "POZASĄDOWE",
          readed: "no",
          clientId: props.clientsData.id,
          task_conn: "c",
          team: props.team,
        };

        await fetch("https://apidevkppp.ftpeople.pl/insertTask", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            if (
              props.clientsData.pel_sub !== undefined &&
              props.clientsData.pel_sub !== null
            ) {
              if (props.clientsData.pel_sub.length > 0) {
                MySwal.fire({
                  icon: "success",
                  title: "Wygenerowano",
                  text: "pismo",
                }).then(async (result) => {
                  props.close();
                });
              } else {
                addPelnSubQ();
              }
            } else {
              addPelnSubQ();
            }
          })
          .catch((error) => {});
      } else if (result.isDenied) {
        if (
          props.clientsData.pel_sub !== undefined &&
          props.clientsData.pel_sub !== null
        ) {
          if (props.clientsData.pel_sub.length > 0) {
            MySwal.fire({
              icon: "success",
              title: "Wygenerowano",
              text: "pismo",
            }).then(async (result) => {
              props.close();
            });
          } else {
            addPelnSubQ();
          }
        } else {
          addPelnSubQ();
        }
      }
    });
  };

  const addPelnSubQ = () => {
    MySwal.fire({
      title: "Czy chcesz dodać pełnomocnika substytucyjnego?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowEditPelnSub(true);
      } else if (result.isDenied) {
        MySwal.fire({
          icon: "success",
          title: "Wygenerowano",
          text: "pismo",
        }).then(async (result) => {
          props.close();
        });
      }
    });
  };

  const getTemplateName = (value) => {
    var name = letters.filter((el) => el.link === value);
    if (name.length > 0) {
      setTask(name[0].task);
      return name[0].name;
    } else {
      setTask("inne");
      return "nie znaleziono";
    }
    if (value === "./asd.docx") {
      setTask("Wniosek o podjęcie czynności");
      return "Wniosek o podjęcie czynności";
    }
    if (value === "./asd1.docx") {
      setTask("Adres e-mail");
      return "Adres e-mail i nr telefonu pełnomocnika i powodów";
    }
    if (value === "./asd2.docx") {
      setTask("Oświadczenie o skutkach nieważności");
      return "Pouczenie o skutkach nieważności";
    }
    if (value === "./asd3.docx") {
      setTask("Inny");
      return "Pouczenie - potwierdzenie nadania";
    }
    if (value === "./asd4.docx") {
      setTask("Propozycja ugodowa");
      return "Ugoda - brak możliwości zawarcia";
    }
    if (value === "./asd5.docx") {
      setTask("Odpowiedź na zobowiązanie sądu");
      return "Ustosunkowanie się do zawieszenia postępowania";
    }
    if (value === "./asd6.docx") {
      setTask("Wniosek o podjęcie czynności");
      return "Wniosek o podjęcie czynności - przekazanie akt - II instancja";
    }
    if (value === "./asd7.docx") {
      setTask("Wniosek o podjęcie czynności");
      return "Wniosek o podjęcie czynności - II instancja";
    }
    if (value === "./asd8.docx") {
      setTask("Wniosek o podjęcie czynności");
      return "Wniosek o podjęcie czynności - niezwłoczny - I i II instancja";
    }
    if (value === "./asd9.docx") {
      setTask("Wniosek o podjęcie czynności");
      return "Wniosek o podjęcie czynności - ogólny I instancja";
    }
    if (value === "./asd10.docx") {
      setTask("Wniosek o rozprawę online");
      return "Wniosek o rozprawę online";
    }
    if (value === "./asd11.docx") {
      setTask("Inny");
      return "Wniosek o zeznanie świadka";
    }
    if (value === "./asd12.docx") {
      setTask("Zaliczka na biegłego");
      return "Zaliczka na biegłego";
    }
    if (value === "./asd13.docx") {
      setTask("Zażalenie");
      return "Zażalenie - odrzucenie GETIN";
    }
    if (value === "./asd14.docx") {
      setTask("Pełnomocnictwo");
      return "Zgłoszenie substytucji";
    }
    if (value === "./asd15.docx") {
      setTask("Odpowiedź na zażalenie");
      return "Odpowiedź na zażalenie 730 731 GEMoney par. 17";
    }
    if (value === "./asd16.docx") {
      setTask("Odpowiedź na zażalenie");
      return "Odpowiedź na zażalenie 730 i 731";
    }
    if (value === "./asd17.docx") {
      setTask("Odpowiedź na zażalenie");
      return "Odpowiedź na zażalenie 730";
    }
    if (value === "./asd18.docx") {
      setTask("Zażalenie");
      return "Zażalenie zabezpieczenie z TSUE i spłaty w CHF";
    }
    if (value === "./asd19.docx") {
      setTask("Zażalenie");
      return "Zażalenie zabezpieczenie z TSUE";
    }
    if (value === "./asd22.docx") {
      setTask("Wniosek o objęcie sprawy nadzorem");
      return "Wniosek o objęcie sprawy nadzorem";
    }
    if (value === "./asd28.docx") {
      setTask("Replika - Bank Millenium S.A.");
      return "Replika - Bank Millenium S.A.";
    }

    if (value === "./asd29.docx") {
      setTask("Odpowiedź na apelację - PKO BP S.A.");
      return "Odpowiedź na apelację - PKO BP S.A.";
    }

    if (value === "./asd30.docx") {
      setTask("Replika - indeksowany");
      return "Replika - indeksowany";
    }

    if (value === "./asd31.docx") {
      setTask("Replika - GE Money Bank S.A.");
      return "Replika - GE Money Bank S.A.";
    }

    if (value === "./asd32.docx") {
      setTask("Replika - denominowany");
      return "Replika - denominowany";
    }

    if (value === "./asd34.docx") {
      setTask("Pytania do świadków");
      return "Pytania do świadków";
    }

    if (value === "./asd35.docx") {
      setTask("Replika - indeksowany, denominowany + Millennium");
      return "Replika - indeksowany, denominowany + Millennium";
    }

    if (value === "./asd36.docx") {
      setTask("Wniosek o uzasadnienie postanowienia");
      return "Wniosek o uzasadnienie postanowienia";
    }

    if (value === "./asd37.docx") {
      setTask("Wniosek o uzasadnienie wyroku");
      return "Wniosek o uzasadnienie wyroku";
    }

    if (value === "./asd38.docx") {
      setTask("Wniosek o zabezpieczenie");
      return "Wniosek o zabezpieczenie";
    }

    if (value === "./asd42.docx") {
      setTask("Oświadczenie o potrąceniu PLN więcej niż 1 kredytobiorca");
      return "Oświadczenie o potrąceniu PLN więcej niż 1 kredytobiorca";
    }

    if (value === "./asd43.docx") {
      setTask("Oświadczenie o potrąceniu PLN");
      return "Oświadczenie o potrąceniu PLN";
    }

    if (value === "./asd44.docx") {
      setTask("Oświadczenie o potrąceniu PLN+CHF więcej niż 1 kredytobiorca");
      return "Oświadczenie o potrąceniu PLN+CHF więcej niż 1 kredytobiorca";
    }

    if (value === "./asd45.docx") {
      setTask("Oświadczenie o potrąceniu PLN+CHF");
      return "Oświadczenie o potrąceniu PLN+CHF";
    }

    if (value === "./asd46.docx") {
      setTask("Wniosek dowodowy - oświadczenie o potrąceniu");
      return "Wniosek dowodowy - oświadczenie o potrąceniu";
    }

    if (value === "./asd47.docx") {
      setTask("Oświadczenie SKD (składane przez kredytobiorcę)");
      return "Oświadczenie SKD (składane przez kredytobiorcę)";
    }
  };

  const handleTemplateChange = (e) => {
    var value = e.target.value;

    var name = letters.filter((el) => el.link === value);
    if (name.length > 0) {
      setTask(name[0].task);
      setTemplate(name[0].link);
    } else {
      setTask("inne");
      setTemplate(null);
    }

    return;

    if (value === "./asd.docx") {
      setTask("Wniosek o podjęcie czynności");
    }
    if (value === "./asd1.docx") {
      setTask("Adres e-mail");
    }
    if (value === "./asd2.docx") {
      setTask("Oświadczenie o skutkach nieważności");
    }
    if (value === "./asd3.docx") {
      setTask("Inny");
    }
    if (value === "./asd4.docx") {
      setTask("Propozycja ugodowa");
    }
    if (value === "./asd5.docx") {
      setTask("Odpowiedź na zobowiązanie sądu");
    }
    if (value === "./asd6.docx") {
      setTask("Wniosek o podjęcie czynności");
    }
    if (value === "./asd7.docx") {
      setTask("Wniosek o podjęcie czynności");
    }
    if (value === "./asd8.docx") {
      setTask("Wniosek o podjęcie czynności");
    }
    if (value === "./asd9.docx") {
      setTask("Wniosek o podjęcie czynności");
    }
    if (value === "./asd10.docx") {
      setTask("Wniosek o rozprawę online");
    }
    if (value === "./asd11.docx") {
      setTask("Inny");
    }
    if (value === "./asd12.docx") {
      setTask("Zaliczka na biegłego");
    }
    if (value === "./asd13.docx") {
      setTask("Zażalenie");
    }
    if (value === "./asd14.docx") {
      setTask("Pełnomocnictwo");
    }
    if (value === "./asd15.docx") {
      setTask("Odpowiedź na zażalenie");
    }
    if (value === "./asd16.docx") {
      setTask("Odpowiedź na zażalenie");
    }
    if (value === "./asd17.docx") {
      setTask("Odpowiedź na zażalenie");
    }
    if (value === "./asd18.docx") {
      setTask("Zażalenie");
    }
    if (value === "./asd19.docx") {
      setTask("Zażalenie");
    }
    if (value === "./asd22.docx") {
      setTask("Wniosek o objęcie sprawy nadzorem");
    }

    if (value === "./asd28.docx") {
      setTask("Replika - Bank Millenium S.A.");
    }
    if (value === "./asd29.docx") {
      setTask("Odpowiedź na apelację - PKO BP S.A.");
    }
    if (value === "./asd30.docx") {
      setTask("Replika - indeksowany");
    }
    if (value === "./asd31.docx") {
      setTask("Replika - GE Money Bank S.A.");
    }
    if (value === "./asd32.docx") {
      setTask("Replika - denominowany");
    }
    if (value === "./asd34.docx") {
      setTask("Pytania do świadków");
    }
    if (value === "./asd35.docx") {
      setTask("Replika - indeksowany, denominowany + Millennium");
    }
    if (value === "./asd36.docx") {
      setTask("Wniosek o uzasadnienie postanowienia");
    }
    if (value === "./asd37.docx") {
      setTask("Wniosek o uzasadnienie wyroku");
    }
    if (value === "./asd38.docx") {
      setTask("Wniosek o zabezpieczenie");
    }
    if (value === "./asd42.docx") {
      setTask("Oświadczenie o potrąceniu PLN więcej niż 1 kredytobiorca");
    }
    if (value === "./asd43.docx") {
      setTask("Oświadczenie o potrąceniu PLN");
    }
    if (value === "./asd44.docx") {
      setTask("Oświadczenie o potrąceniu PLN+CHF więcej niż 1 kredytobiorca");
    }
    if (value === "./asd45.docx") {
      setTask("Oświadczenie o potrąceniu PLN+CHF");
    }
    if (value === "./asd46.docx") {
      setTask("Wniosek dowodowy - oświadczenie o potrąceniu");
    }
    if (value === "./asd47.docx") {
      setTask("Oświadczenie SKD (składane przez kredytobiorcę)");
    }

    setTemplate(e.target.value);
  };

  const closeEditPelnSub = (e) => {
    setShowEditPelnSub(false);
    props.close();
  };

  return (
    <div
      style={{ width: "50vw", top: "35vh" }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          {showEditPelnSub ? (
            <EditPelnSub
              close={closeEditPelnSub}
              refreshData={props.refreshData}
              clientsData={props.clientsData}
              clientsSheetData={props.clientsSheetData}
              logClientAction={props.logClientAction}
              client={props.clientsData}
              userName={props.user}
              mode="letter"
            />
          ) : (
            ""
          )}
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div id="addPaymentIC" className="inputContainer">
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Wybierz szablon <span className="requiredStar">*</span>
                </label>
                <select
                  type="text"
                  id="court"
                  name="court"
                  value={template}
                  onChange={handleTemplateChange}
                >
                  {template === "" ? (
                    <option key={0} value={""}>
                      {"Wybierz..."}
                    </option>
                  ) : (
                    ""
                  )}
                  {letters.map((el) => (
                    <>
                      <option key={el.id} value={el.link}>
                        {el.name}
                      </option>
                    </>
                  ))}
                </select>
              </div>
            </div>

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={generateDocument}>
                Wygeneruj
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddLetter;
